export const skinCustom = {
  lightComponents: {
    body: '#f1f1f1',
    gradient: {
      gradientDefault1: '#087f5b',
      gradientDefault2: '#087f5b',
    },
  },
  darkComponents: {
    body: '#263238',
    gradient: {
      gradientDefault1: '#172260',
      gradientDefault2: '#000000',
    },
  },
}

export const image = {
  principal: 'https://quicksoftcertificado.com.br/image-bank/image.png',
  favicon: 'https://quicksoftcertificado.com.br/image-bank/imagelogo.png',
}

export const seo = {
  titulo: 'Quick Soft Tecnologia da Informação S.A',
  email: 'suporte@quicksoft.com.br',
  palavrasChave:
    'Certificado Digital, Cnpj a1, Cpf a1, emitir certificado, certificado Blumenau',
  descricao:
    'Empresa líder em Certificação Digital, oferecendo soluções seguras e confiáveis para empresas e indivíduos, com ampla experiência no mercado.',
  descricaoPWA:
    'Certificados digitais são identidades eletrônicas seguras usadas para autenticar usuários, proteger informações e realizar transações online com segurança.',
}

export const header = {
  empresa: false,
  solucoes: false,
  contato: true,
  trabalheConosco: false,
  duvidasSuporte: true,
  parcerias: false,
  darkMode: false,
  contaLogin: false,
}

export const contentHome = {
  sispass: false,
  produtorRural: false,
  modalidadesCertificado: false,
}

export const footer = {
  is0800: false,
  telefone: '47 3231-6500',
  whatsapp: '41 9786-0089', 
  botaoRenocao: '4197860089',
  comercial: '4197860089',
  botaoWhatsapp: '4197860089',
  number0800: '0800 600 2710',
  cidadeuf: 'Blumenau/SC',
  cidade: 'Blumenau',
  bairro: 'Testo Salto',
  titulo: 'Certificado Digital em Blumenau',
  rua: 'Rua Werner Duwe',
  numero: '4776',
  complemento: '',
  cep: '89074-178',
  cnpj: '00.565.447/0001-08',
  messageContador: 'Olá, tenho interesse em ser Parceiro Indicador.',
  messageRevenda: 'Olá, tenho interesse em revender Certificados Digitais',
  messageAgendamento: 'Olá, estou no site da Qcertifica e gostaria de agendar a emissão do meu Certificado Digital.',
  messageRenovacao: 'Olá, gostaria de renovar meu Certificado Digital',
  messageRenovacaoSispass:
    'Olá, gostaria de renovar meu Certificado Digital Sispass',
  messageConhecaNossasSolucoes:
    'Olá, gostaria de conhecer as soluções da Senha Digital',
}

export const redes = {
  facebook: 'https://www.facebook.com/',
  instagram: 'https://www.instagram.com/quick.soft/',
  linkedin: 'https://www.linkedin.com/company/quicksoft-tecnologia/',
}

export const digisac = {
  id: 'df7a6a14-269a-46ba-a874-33c45e74badf',
  status: false,
}

export const ratings = [
  {
    id: 1,
    descricao: 'Suporte e Atendimento excelentes!',
    author: 'Leonardo Lopes',
    ratingvalue: 5,
  },
  {
    id: 2,
    descricao:
      'Atendimento excelente. Super ágil, prático e simplificado! Ótima organização da equipe.',
    author: 'Tháliton Morais',
    ratingvalue: 5,
  },
  {
    id: 3,
    descricao: 'Atendimento do Suporte Técnico nota 10!.',
    author: 'Felipe Mourão',
    ratingvalue: 5,
  },
]
